import {NgModule} from '@angular/core';
import {CommonModule, NgClass, NgIf} from "@angular/common";
import {UserDataComponent} from "@iw-shop/user/components/data/user-data.component";
import {UserLoginComponent} from "@iw-shop/user/components/login/user-login.component";
import {UserPasswordLostComponent} from "@iw-shop/user/components/password-lost/user-password-lost.component";
import {UserPasswordReset} from "@iw-shop/user/components/password-reset/user-password-reset.component";
import {UserPasswordUpdateComponent} from "@iw-shop/user/components/password-update/user-password-update.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MyFormsModule} from "@iw-shop/forms/my-forms.module";
import {CaptchaModule} from "@iw-shop/captcha/captcha.module";
import {RouterLink} from "@angular/router";
import {TooltipModule} from "primeng/tooltip";
import {CoreModule} from "@iw-shop/core/core.module";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        UserDataComponent,
        UserLoginComponent,
        UserPasswordLostComponent,
        UserPasswordReset,
        UserPasswordUpdateComponent
    ],
    imports: [
        NgClass,
        NgIf,
        ReactiveFormsModule,
        CaptchaModule,
        MyFormsModule,
        CommonModule,
        FormsModule,
        RouterLink,
        TooltipModule,
        CoreModule,
        FaIconComponent

    ],
    exports: [
        UserDataComponent,
        UserLoginComponent,
        UserPasswordLostComponent,
        UserPasswordReset,
        UserPasswordUpdateComponent
    ]
})
export class UserModule {
}
